/**
 * Checks whether a value is an HTTPS URL string.
 *
 * @param {string | File | undefined} url The value to inspect.
 * @returns {boolean} True when the value starts with `https`.
 */
export const isHttps = (url?: string | File): boolean => {
  if (!url || typeof url !== "string") {
    return false;
  }

  return url.startsWith("https");
};

/**
 * Checks whether a pathname matches a route, ignoring trailing slashes.
 *
 * @param {string} pathname The actual URL pathname.
 * @param {string} route The route to compare against.
 * @returns {boolean} True when the stripped pathname equals the route.
 */
export const isRouteMatch = (pathname: string, route: string): boolean => {
  const normalize = (p: string): string => p.replace(/\/+$/, "") || "/";
  return normalize(pathname) === normalize(route);
};
